import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8 5v14l11-7z"
}), 'PlayArrow');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlayArrow.js
// module id = 5497
// module chunks = 2